import { getCookie } from '@src/shared/utils/cookie'
import { logWarn } from '@src/shared/utils/logging'

// Returns the Forter token (cookie first, then the SDK's tokenReady value) and logs a warning if it is missing or the
// SDK failed to load ('UDF9' in the token's ex segment)
export const getForterToken = (context: string) => {
  const cookie = getCookie('forterToken')
  const token = cookie || window.__FVR__?.forterId?.split('_tt')[0]

  const issue = !token ? 'missing' : token.split('_')[3]?.includes('UDF9') ? 'sdk-load-failed' : null
  if (issue) {
    logWarn(`Forter token ${issue} at ${context}`, { forterIssue: issue, hasCookie: !!cookie }, 'Forter')
  }

  return token
}
